enum PaymentStatus {
  Pending = 1,
  Settled = 2,
  Cancelled = 3,
  Failed = 4
}

export const PaymentEnum = { PaymentStatus }
